module.exports = __webpack_public_path__ + "static/sf_2.56f030e6.png";